import type { CheckInType, EventStatus, PaymentMethod } from '@linka/domain/enums';
import type { ReportDownloadRequest } from '@linka/domain/requests';
import type { ExportFilters } from './context';

interface BuildExportPayloadParams {
  reportType: ReportDownloadRequest['reportType'];
  format: ReportDownloadRequest['format'];
  applyFilters: boolean;
  filters: ExportFilters;
}

export function buildExportPayload({
  reportType,
  format,
  applyFilters,
  filters,
}: BuildExportPayloadParams): ReportDownloadRequest {
  const payload: ReportDownloadRequest = { reportType, format };

  if (applyFilters) {
    payload.ticketsIds = filters.ticketsIds;
    payload.paymentMethods = filters.paymentMethods as PaymentMethod[];
    payload.startDate = filters.startDate;
    payload.endDate = filters.endDate;
  }

  // O "Venda por tipo" da tabela de vendas concluídas é filtro da própria tabela (URL), não do painel:
  // só o relatório de vendas o entende, e só quando o organizador pede para aplicar os filtros.
  if (applyFilters && reportType === 'SALES') {
    payload.saleType = filters.saleType;
  }

  if (reportType === 'ORDERS_CHECKOUT') {
    payload.status = filters.status as EventStatus;
  }

  if (reportType === 'CHECKIN') {
    payload.type = filters.type as CheckInType;
  }

  return payload;
}
